import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight, ShieldCheck, MapPinned, HeartHandshake } from "lucide-react";

const AboutPage = () => {
  const { t, lang } = useLang();

  return (
    <div data-testid="about-page" className="fade-in">
      <section className="relative overflow-hidden bg-[#F3E6DA] grain">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36 grid lg:grid-cols-5 gap-12 items-center relative">
          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.28em] font-bold text-[#8B5A3C] mb-5">{t.about.eyebrow}</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight text-[#2C2621] whitespace-pre-line mb-8">
              {t.about.title}
            </h1>
            <p className="text-[#5C544B] text-lg leading-relaxed mb-5">{t.about.p1}</p>
            <p className="text-[#5C544B] text-lg leading-relaxed">{t.about.p2}</p>
          </div>
          <div className="lg:col-span-2">
            <img
              src="https://images.pexels.com/photos/19433237/pexels-photo-19433237.jpeg?auto=compress&cs=tinysrgb&w=940"
              alt="Pisa"
              className="rounded-[2rem] object-cover w-full h-[480px]"
            />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-24">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: ShieldCheck, ...t.about.values[0] },
            { icon: MapPinned, ...t.about.values[1] },
            { icon: HeartHandshake, ...t.about.values[2] },
          ].map((v, i) => (
            <div key={i} className="bg-white border border-[#E8DFD8] rounded-2xl p-8 hover:border-[#8B5A3C] hover:-translate-y-1 transition-all duration-300">
              <div className="w-14 h-14 rounded-full bg-[#F3E6DA] flex items-center justify-center mb-5">
                <v.icon size={22} className="text-[#8B5A3C]" />
              </div>
              <h3 className="font-display text-2xl font-medium text-[#2C2621] mb-3">{v.title}</h3>
              <p className="text-sm text-[#5C544B] leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="bg-[#2C2621] rounded-[2rem] p-10 md:p-16 text-white grid md:grid-cols-3 gap-8 items-center">
          <div className="md:col-span-2">
            <h2 className="font-display text-3xl sm:text-4xl font-medium leading-tight mb-4">
              {lang === "it" ? "Pronto a iniziare?" : "Ready to start?"}
            </h2>
            <p className="text-white/75 leading-relaxed">
              {lang === "it"
                ? "Vieni a trovarci in via Livia Gereschi a Pisa, oppure richiedi una consulenza online."
                : "Come visit us at via Livia Gereschi in Pisa, or request an online consultation."}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-3 md:items-end">
            <Link to="/contatti" className="bg-[#CBA37E] text-[#2C2621] hover:bg-white transition-colors rounded-full px-7 py-3.5 font-medium inline-flex items-center justify-center gap-2">
              {t.nav.contact} <ArrowRight size={15} />
            </Link>
            <Link to="/valutazione" className="border-2 border-white/40 text-white hover:bg-white hover:text-[#2C2621] transition-colors rounded-full px-7 py-3.5 font-medium text-center">
              {t.nav.evaluation}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
